import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDPrimaryActionButton, FDStack, FDTextButton,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';

export const IntroContent = () => {
  const {
    resource, onSubmit, saving, handleChange,
  } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();

  return (
    <FDStack direction={'column'} spacing={8}>
      <FDStack direction={'column'} spacing={2}>
        <MetaControlField attr={'introTitle'} />
        <MetaControlField attr={'introDescription'} />
      </FDStack>
      <FDStack direction={'column'} spacing={2}>
        <FDStack alignItems={'center'} spacing={2} justifyContent={'center'}>
          <WizardBackButtonRel overrideOnClick={(_, rel) => loadPageContentLink(rel.link('related'))} resource={resource} />
          <FDPrimaryActionButton
            alignSelf={'center'}
            {...dataAttrs('add-btn', resource)}
            label={resource.attr('introPrimaryActionLabel')}
            onClick={() => handleChange('hasTrustedContact', 'true')}
          />
        </FDStack>
        {resource.meta().canSubmit() ? <FDTextButton
          {...dataAttrs('continue-btn', resource)}
          loading={saving}
          label={resource.attr('introSecondaryActionLabel')}
          onClick={onSubmit}
          alignSelf="center"
        /> : null}
      </FDStack>
    </FDStack>
  );
};
